module.exports = __webpack_public_path__ + "static/img/10.94d56dca.png";